export default "__VITE_ASSET__JnXXzd$0isqcT1bupm3T6Q__"